<template>
  <div>
    <sn-label
      v-if="label"
      class="mb-2"
      :data-cy="`${dataCy}-label`"
      :title="label"
      :optional="showOptionalLabel"
    />
    <v-text-field
      v-bind="effectiveBindings"
      class="sn-text-field"
      :data-cy="dataCy"
      data-lpignore="true"
      v-on="$listeners"
    >
      <slot
        v-for="slot in Object.keys($slots)"
        :slot="slot"
        :name="slot"
      />
    </v-text-field>
  </div>
</template>

<script>
import vuetifyOverrideMixin from '~/components/snui/v2/mixins/vuetifyOverrideMixin.vue'
import SnLabel from '~/components/snui/v2/snLabel/snLabel'
import { cypressMixin } from '../mixins/cypressMixin'
export default {
  name: 'SnTextField',
  components: { SnLabel },
  mixins: [vuetifyOverrideMixin, cypressMixin],
  props: {
    label: { type: String, default: '' },
    showOptionalLabel: { type: Boolean, default: false }
  },
  data () {
    return {
      vuetifyOverrideMixin: {
        defaultProps: {
          hideDetails: 'auto'
        },
        overriddenProps: {
          appendIcon: undefined,
          appendOuterIcon: undefined,
          backgroundColor: undefined,
          clearIcon: '$snExit',
          color: undefined,
          counter: undefined,
          counterValue: null,
          dark: false,
          dense: false,
          errorCount: 1,
          filled: false,
          flat: false,
          fullWidth: false,
          height: undefined,
          hideSpinButtons: false,
          label: undefined,
          light: false,
          loaderHeight: 2,
          loading: false,
          messages: [],
          outlined: false,
          persistentHint: true,
          persistentPlaceholder: false,
          prependIcon: undefined,
          prependInnerIcon: undefined,
          reverse: false,
          rounded: false,
          shaped: false,
          singleLine: false,
          solo: false,
          soloInverted: false,
          success: false,
          successMessages: []
        }
      }
    }
  },
  computed: {
    effectiveBindings () {
      var bindings = {
        ...this.vuetifyOverrideMixin.bindings
      }
      return bindings
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/components/snui/v2/mixins/vuetifyOverrideCss.scss';

.sn-text-field {
  @extend .v-text-field--sn_override;
}

</style>
